module.exports = __webpack_public_path__ + "images/halloween_lp/sec02_title_1d27768e19c1ece3bbae9ad0c7b634b7.png";